module.exports = __webpack_public_path__ + "img/team-dominik.2a747bde.jpg";